import { Component, OnInit } from '@angular/core';
import { AllRldService } from './all-rld.service';

@Component({
  selector: 'app-all-rld',
  templateUrl: './all-rld.component.html',
  styleUrls: ['./all-rld.component.scss']
})
export class AllRldComponent implements OnInit {
  loading: boolean = true;
  sourceDropdownOptions: any[];
  selectedSource: string;
  allRldData: any;
  filteredData: any[] = [];
  email: any;

  showSalesDialog(item: any) {
    this.closeAllModals();
    item.new_price = true;
  }

  closeAllModals() {
    for (const item of this.filteredData) {
      item.new_price = false;
    }
  }


  constructor(private AllRldService: AllRldService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getAllRldData();

    this.sourceDropdownOptions = [
      { label: 'Some Are Zero', value: 'Some Are Zero' },
      { label: 'All Are Zero', value: 'All Are Zero' },
    ];

    this.selectedSource = 'Some Are Zero';

  }

  filterData() {
    if (this.selectedSource === 'Some Are Zero') {
      this.filteredData = this.allRldData.filter(item => item.all_rld_or_not === 'Some Are Zero');
      console.log("filtered data some", this.filteredData);
    } else if (this.selectedSource === 'All Are Zero') {
      this.filteredData = this.allRldData.filter(item => item.all_rld_or_not === 'All Are Zero');
      console.log("filtered data all", this.filteredData);
    }
  }

  getAllRldData() {
    this.AllRldService.getAllRldData(this.email).subscribe((response) => {
      this.allRldData = response["data"];
      console.log("resss", this.allRldData);
      this.filterData();
      this.loading = false;
    });
  }

}
